import { Injectable } from '@angular/core';
import { DataService } from './core/data.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService extends DataService {
  context = 'documento';

  getPlanilhaRateio() {
    const parametro = "";
    const apiURL = `${environment.apiUrl}/api/Documento?tipoOperacao=${parametro}`;
    return this.http.get(apiURL, { responseType: 'arraybuffer' });
  }

  getPlanilhaRateioFiscal() {
    const parametro = "PlanilhaRateioFiscal";
    const apiURL = `${environment.apiUrl}/api/Documento?tipoOperacao=${parametro}`;
    return this.http.get(apiURL, { responseType: 'arraybuffer' });
  }

  getPlanilhaRateioNaoFiscal() {
    const parametro = "PlanilhaRateioNaoFiscal";
    const apiURL = `${environment.apiUrl}/api/Documento?tipoOperacao=${parametro}`;
    return this.http.get(apiURL, { responseType: 'arraybuffer' });
  }

  getSavePrint() {
    const parametro = "GetSavePrint";
    const apiURL = `${environment.apiUrl}/api/Documento?tipoOperacao=${parametro}`;
    return this.http.get(apiURL, { responseType: 'arraybuffer' });
  }

  obterDocumentoDuvida() {
    const parametro = "duvida";
    const apiURL = `${environment.apiUrl}/api/Documento?tipoOperacao=${parametro}`;
    return this.http.get(apiURL, { responseType: 'arraybuffer' });
  }

}
